import { styled } from '@mui/system';

export const NavigatorWrapper = styled('aside')(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  height: '100vh',
  display: 'grid',
  gridTemplateRows: 'min-content auto min-content',
}));